import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, Sparkles } from 'lucide-react';
import { HERO_STATS } from '../data/content';
import HeroAI from './HeroAI';

export default function Hero() {
  return (
    <section id="top" className="relative pt-[110px] pb-24 overflow-hidden paper-radial">
      <div className="absolute inset-0 hero-grid opacity-70 pointer-events-none"/>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-[1.15fr_1fr] gap-10 items-center">
        <div className="min-w-0">
          <motion.div initial={{opacity:0, y:20}} animate={{opacity:1, y:0}} transition={{duration:0.6}} className="inline-flex items-center gap-2 border border-[#293891]/25 bg-white/70 backdrop-blur-sm rounded-full px-4 py-2 text-[11px] tracking-[0.2em] uppercase text-[#293891] font-semibold">
            <Sparkles size={14} className="text-[#E63329]"/> ExcellenC · Professional Program
          </motion.div>

          <motion.h1 initial={{opacity:0, y:30}} animate={{opacity:1, y:0}} transition={{duration:0.7, delay:0.1}} className="font-display text-[#293891] mt-6 leading-[0.95] font-semibold text-[54px] sm:text-[72px] lg:text-[86px]">
            AI-Powered
            <div className="text-stroke font-display leading-[0.95]">Data Science</div>
            <div className="text-[#E63329] font-display leading-[0.95]">Professional Program</div>
          </motion.h1>

          <motion.p initial={{opacity:0}} animate={{opacity:1}} transition={{duration:0.8, delay:0.35}} className="mt-8 max-w-xl text-[15px] leading-relaxed text-[#293891]/75">
            A live, mentor-led program engineered for the AI era — blending Machine Learning, Deep Learning, Generative & Agentic AI with real-time industry projects and the exact tools employers demand. Learn to build intelligent, data-driven solutions that move businesses forward.
          </motion.p>

          <motion.div initial={{opacity:0, y:20}} animate={{opacity:1, y:0}} transition={{duration:0.7, delay:0.5}} className="mt-10 grid grid-cols-3 gap-3 max-w-lg">
            {HERO_STATS.map(s => (
              <div key={s.title} className="bg-white/85 backdrop-blur-sm border border-[#293891]/10 rounded-2xl px-4 py-4">
                <div className="font-display text-[22px] sm:text-[26px] font-semibold text-[#293891]">{s.title}</div>
                <div className="text-[9.5px] sm:text-[10.5px] tracking-[0.18em] mt-1 text-[#293891]/75 font-semibold">{s.sub}</div>
              </div>
            ))}
          </motion.div>

          <motion.a initial={{opacity:0}} animate={{opacity:1}} transition={{delay:0.75}} href="#overview" className="mt-12 inline-flex items-center gap-3 text-[13px] font-medium text-[#293891]/80 hover:text-[#E63329] transition-colors">
            <span className="w-9 h-9 border border-[#293891]/30 rounded-full flex items-center justify-center">
              <ArrowDown size={14}/>
            </span>
            Scroll to explore the program
          </motion.a>
        </div>

        <div className="relative min-w-0 h-[360px] min-[480px]:h-[480px] lg:h-[560px]">
          <HeroAI/>
        </div>
      </div>
    </section>
  );
}
